module.exports = __webpack_public_path__ + "img/Group 2124.5ed335eb.svg";